import ApiService from './api.service'

const CoachService = {
  index (search = '', page = 1) {
    return ApiService.get(`api/v1/admin/coaches?search=${search}&page=${page}`)
  },

  show (uuid) {
    return ApiService.get('api/v1/admin/coaches/' + uuid)
  },

  update (uuid, data) {
    return ApiService.put('api/v1/admin/coaches/' + uuid, data)
  },

  store (data) {
    return ApiService.post('api/v1/admin/coaches', data)
  }
}

export default CoachService
